// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { NerdStatsGetString, StatsForNerdsModalGetString, NerdStatsHelpLinkGetString } from './types.generated'

const nerdStatsLocales = ['en-US'] as const

export const getString: NerdStatsGetString = i18nBundle('nerdStats', nerdStatsLocales).getString
export const getStringNerdStats: NerdStatsGetString = getString

const statsForNerdsModalLocales = ['en-US'] as const

export const getStringStatsForNerdsModal: StatsForNerdsModalGetString = i18nBundle('StatsForNerdsModal', statsForNerdsModalLocales).getString

const nerdStatsHelpLinkLocales = ['en-US'] as const

export const getStringNerdStatsHelpLink: NerdStatsHelpLinkGetString = i18nBundle('NerdStatsHelpLink', nerdStatsHelpLinkLocales).getString

